export const brohnHomes = {
    fontFamilyImport: [],
  transitionMain: "all 300ms ease-in-out",

  fieldTopSpacing: 24,
  inputPaddingInline: 25,

  inputHeight: 45,
  inputWidth: '100',
  inputWidthUnits: "%",

  inputFontSize: 21,
  inputFontFamily: '"Noto Sans Display", sans-serif',
  inputColor: "#696969",
  inputBackgroundColor: "#ffffff",
  inputFontWeight: 400,

  inputBorderColor: "#707070",
  inputBorderWidth: 1,
  inputBorderRadius: 10,

  inputHoverColor: "#696969",
  inputHoverBorderColor: "#707070",
  inputHoverBackgroundColor: "#ffffff",

  // **********************************
  //  Select field
  selectTopSpacing: 24,
  selectPaddingInline: 25,

  selectHeight: 45,
  selectWidth: '100',
  selectWidthUnits: "%",

  selectFontSize: 21,
  selectFontFamily: '"Noto Sans Display", sans-serif',
  selectColor: "#696969",
  selectBackgroundColor: "#ffffff",
  selectFontWeight: 400,

  selectBorderColor: "#707070",
  selectBorderWidth: 1,
  selectBorderRadius: 10,

  selectHoverColor: "#696969",
  selectHoverBorderColor: "#707070",
  selectHoverBackgroundColor: "#ffffff",

  addSelectBackgroundImage: false,
  selectBackgroundImage: '',
  selectBackgroundImagePositionRight: 10,
  selectBackgroundImageSize: 20,

  // **********************************
  //  Text Area field
  textAreaTopSpacing: 24,
  textAreaPaddingInline: 25,

  textAreaHeight: 45,
  textAreaWidth: '100',
  textAreaWidthUnits: "%",

  textAreaFontSize: 21,
  textAreaFontFamily: '"Noto Sans Display", sans-serif',
  textAreaColor: "#696969",
  textAreaBackgroundColor: "#ffffff",
  textAreaFontWeight: 400,

  textAreaBorderColor: "#707070",
  textAreaBorderWidth: 1,
  textAreaBorderRadius: 10,

  textAreaHoverColor: "#696969",
  textAreaHoverBorderColor: "#707070",
  textAreaHoverBackgroundColor: "#ffffff",

  // **********************************
  //  placeholder
  placeholderColor: "#707070",
  placeholderFontFamily: '"Noto Sans Display", sans-serif',
  placeholderFontSize: 21,
  placeholderFontWeight: 400,
  placeholderHoverColor: "#707070",

  // **********************************
  // script
  addPlaceholders: false,
  removeFieldLabels: false,

  // **********************************
  //  field label
  fieldLabelBottomSpacing: 5,
  fieldLabelPadding: 0,
  fieldLabelFontSize: 21,
  fieldLabelColor: "#707070",
  fieldLabelFontWeight: 400,
  fieldLabelColorAsterisk: "#707070",
  fieldLabelAlignment: "column",
  fieldLabelFontFamily: '"Noto Sans Display", sans-serif',

  // **********************************
  //  description
  descriptionPaddingInline: 0,
  descriptionColor: "#707070",
  descriptionFontSize: 21,
  descriptionFontWeight: 400,
  descriptionFontFamily: '"Noto Sans Display", sans-serif',
  descriptionTopSpacing: 5,

  // **********************************
  // checkbox

  addCheckbox: false,
  checkedCheckboxContent: "",
  checkboxInputSize: 30,
  checkboxBorderWidth: 1,
  checkboxBorderRadius: 10,
  checkboxUncheckedBorderColor: "#707070",
  checkboxUncheckedBackgroundColor: "#FFFFFF",
  checkboxCheckedBackgroundColor: "#1FBBB0",
  checkboxCheckedBorderColor: "#707070",
  checkboxCheckedColor: "#fff",
  checkboxAlignment: "none",
  checkboxLabelFontFamily: '"Noto Sans Display", sans-serif',
  checkboxLabelFontSize: 21,
  checkboxLabelFontWeight: 400,
  checkboxLabelColor: "#696969",

  // **********************************
  // radio button

  addRadioButton: false,
  radioInputSize: 30,
  radioBorderWidth: 1,
  radioBorderRadius: 50,

  radioUncheckedBorderColor: "#707070",
  radioUncheckedBackgroundColor: "#fff",
  radioCheckedBackgroundColor: "#1FBBB0",
  radioCheckedBorderColor: "#707070",

  radioAlignment: "none",

  radioLabelFontFamily: '"Noto Sans Display", sans-serif',
  radioLabelFontSize: 21,
  radioLabelFontWeight: 400,
  radioLabelColor: "#696969",

  // **********************************
  // submit button

  submitMarginTop: 23,
  submitFontSize: 21,
  submitFontFamily: "'Noto Sans Display', sans-serif",
  submitWidth: 215,
  submitWidthUnits: "px",
  submitHeight: 55,
  submitBorderRadius: 29,
  submitBorderWidth: 1,
  submitBackground: "#1FBBB0",
  submitColor: "#fff",
  submitBorderColor: "#1FBBB0",
  submitBackgroundHover: "#1FBBB0",
  submitBorderColorHover: "#1FBBB0",
  submitColorHover: "#fff",
  submitTextAlign: "center",
  submitButtonText: "Submit",
  submitFontWeight: 500,
  addBackgroundImage: false,
  submitBackgroundImage: '',
  submitBackgroundImagePositionRight: 10,
  submitBackgroundImageSize: 20,
  submitButtonAlign: "left",
};

  